module.exports = __webpack_public_path__ + "img/bg4.94c2aba2.png";